export default __webpack_public_path__ + "static/media/work-progress.6fefeba2.jpg";